export default "__VITE_ASSET__Cv4Qy1rK__"